import { makeStyles } from '@rbx/ui';

const useReferenceSummaryMemberTableStyles = makeStyles()((theme) => {
  const singleSpace = 4;
  return {
    container: {
      padding: 0,
      margin: theme.spacing(7, 0),
      listStyle: 'none',
      '&:first-of-type': {
        marginTop: theme.spacing(4),
      },
      '&:last-of-type': {
        marginBottom: theme.spacing(8),
      },
    },
    header: {
      display: 'block',
      color: theme.palette.content.muted,
      backgroundColor: theme.palette.surface[300],
      padding: theme.spacing(2, 1.5),
      marginBottom: theme.spacing(2),
      position: 'sticky',
      top: 0,
      zIndex: 1,
      // marginTop: 4
    },
    memberCollectionHeader: {
      color: theme.palette.text.primary,
    },
    divider: {
      margin: theme.spacing(1.5, 0),
      borderColor: '#43454A',
      '& + .summary-tr': {
        borderTop: 'none',
      },
    },
    memberTable: {
      listStyle: 'none',
      margin: theme.spacing(0, 0, 4),
      padding: theme.spacing(0, 1.5),
    },
    // row styles
    tr: {
      borderTop: `solid 1px ${theme.palette.surface[400]}`,
      marginTop: theme.spacing(2),
      paddingTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      '&:first-of-type': {
        marginTop: theme.spacing(0),
        paddingTop: theme.spacing(0.5),
        borderTop: 'none',
      },
      '&:last-of-type': {
        borderBottom: 'none',
        marginBottom: theme.spacing(0),
        '& p': {
          marginBottom: theme.spacing(0),
        },
      },
    },
    trTags: {
      textAlign: 'right',
      [theme.breakpoints.down('Medium')]: {
        textAlign: 'left',
      },
    },
    tagsWrapper: {
      display: 'inline-block',
      [theme.breakpoints.down('XLarge')]: {
        maxWidth: 'initial',
      },
      [theme.breakpoints.down('Large')]: {
        maxWidth: '40vw',
      },
      [theme.breakpoints.down('Medium')]: {
        maxWidth: 'initial',
        marginTop: theme.spacing(1),
      },
      '&.engine': {
        maxWidth: 400,
        marginBottom: theme.spacing(0.5),
      },
    },
    tags: {
      maxWidth: 400,
    },
    tagWrapper: {
      whiteSpace: 'nowrap',
      '&.engine': {
        marginTop: 4,
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
      },
      '&:first-child': {
        marginLeft: 0,
      },
    },
    tagLabel: {
      textTransform: 'capitalize',
    },
    instanceTr: {
      padding: theme.spacing(0, 1.5),
      borderTop: 'none',
      '&:first-of-type': {
        paddingTop: theme.spacing(0),
      },
    },
    titleLink: {
      display: 'inline',
      color: theme.palette.content.action,
      marginRight: singleSpace,
    },
    parameters: {
      marginRight: singleSpace,
    },
    parameter: {
      whiteSpace: 'nowrap',
      display: 'inline-block',
    },
    parameterComma: {
      marginRight: 4,
    },
    parameterType: {
      cursor: 'pointer',
      display: 'inline-block',
      color: theme.palette.content.standard,
      position: 'relative',
    },
    dashedTypeWrapper: {
      // note: pseudoselectors don't work with makeStyles -> need global classname
      '& .dashedType:before': {
        borderBottomStyle: `dashed`,
        borderBottomWidth: 1,
        position: 'absolute',
        content: '" "',
        display: 'block',
        bottom: 0,
        // border bottom is not quite flush to the left.
        // off by 0.25px
        left: 0.25,
        right: 0,
      },
    },
    tagTooltip: {
      margin: 0,
      padding: theme.spacing(1.5, 1),
      minWidth: 10,
    },
    memberTypeTooltip: {
      padding: theme.spacing(1.5, 1),
      '& .tooltipBody': {
        margin: theme.spacing(1, 0, 0),
        color: theme.palette.content.inverse,
      },
      '& .tooltipSubtitle': {
        display: 'block',
        margin: theme.spacing(1, 0, 0),
        fontWeight: 300,
        fontSize: 14,
      },
    },
    memberTypeTooltipLink: {
      textDecoration: 'underline',
    },
    summary: {
      margin: theme.spacing(0.5, 0, 0, 0),
      color: theme.palette.content.muted,
      lineHeight: 1.7,
      '& *': {
        fontSize: 14,
      },
      '& > p': {
        marginBottom: 0,
      },
    },
    inheritedFromLink: {
      fontWeight: 'semibold',
    },
    tooltipWrapper: {
      padding: theme.spacing(1),
    },
  };
});

export default useReferenceSummaryMemberTableStyles;
